import { gql } from "graphql-tag";

export const deleteReadingJournalEntries = gql`
  mutation DeleteReadingJournalEntries($book_id: Int!) {
    deleteResponse: delete_reading_journals_for_book(book_id: $book_id) {
      ids
    }
  }
`;
